import { formatValor } from '../../utils/formatter/formatter'

export const STATUS_VALIDOS_ASSINATURAS_OPCIONAIS = [ 'Ativo', 'Suspenso' ]

export const OPCIONAIS_DOIS_CLUBES = `Assinando os dois clubes, você pode escolher em qual caixinha quer receber.`

export const QUERO_MGM = 'Quero indicar e ganhar'

export const ADICIONAR = 'Adicionar ao kit'

export const DESCRICAO_PIX_PENDENTE = 'Pagamento do PIX pendente. Finalize o pagamento para concluir a compra do item.'

export const DESCRICAO_COMPRADO = 'Você já realizou a compra deste item.'

export const LABEL_OPCIONAL_COMPRADO = 'Comprado'

export const INFO_COMPRA_CARTAO_MODAL =
         'A compra será realizada no cartão de crédito em 1x:'

export const INFO_MAIS_MODALIDADES_MODAL = 'Para efetuar a compra, escolha em qual caixinha você deseja receber o item:'

export const INFO_COMPRA_PIX_MODAL = 'A compra do item será realizada mediante pagamento do PIX gerado a seguir.'

export const DESCRICAO_PAGUE_PIX = 'Escaneie o QR Code ou copie o código para pagar e finalizar a compra do item.'

export const valorOpcional = valor => `Valor total: ${formatValor( { valor } )}`

export const BOTAO_CANCELAR = 'Cancelar'

export const BOTAO_CONFIRMAR = 'Confirmar'

export const BOTAO_FECHAR = 'Fechar'

export const BOTAO_GERAR_PIX = 'Gerar PIX'

export const INFO_OPCIONAIS_SELECIONADOS = 'Abaixo listamos os produtos selecionados por você, confira antes de confirmar o pagamento:'

export const INFO_OPCIONAIS_COMBO = 'Para efetuar a compra, escolha em qual caixinha você deseja receber o item:'

export const CONFIRMAR = 'confirmar'

export const CANCELAR = 'cancelar'

export const BOTOES_PIX = {
  [ CANCELAR ]: {
    'desabilitado': false,
    'texto': BOTAO_CANCELAR
  },
  [ CONFIRMAR ]: {
    'texto': BOTAO_GERAR_PIX
  }
}

export const BOTOES_CARTAO = {
  [ CANCELAR ]: {
    'texto': BOTAO_CANCELAR,
  },
  [ CONFIRMAR ]: {
    'texto': BOTAO_CONFIRMAR
  }
}

export const EVENTOS_PIXEL = {
  'ADICIONAR_NA_CAIXINHA': 'Adicionou opcional',
  'FINALIZOU_OPCIONAL': 'Confirmou opcional',
  'QUERO_INDICAR': 'Indicou amigo'
}

export const TITULO_ERRO_COMPRA = 'Ocorreu um erro.'

export const TITULO_SUCESSO_COMPRA = 'Compra efetuada com sucesso!'

export const TITULO_SUCESSO_PIX = 'PIX gerado!'

export const ERRO_GERAR_PIX = 'Não foi possível gerar o PIX. Tente novamente em alguns instantes. Se o problema persistir, entre em contato com o suporte.'
